import { createRouter } from '@tanstack/react-router';
import { routeTree } from '@/routeTree.gen.ts';
import RouteError from '@/components/RouteError.tsx';

const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultErrorComponent: RouteError,
});

export default router;
